// Puente entre `ApiRest` (JavaScript, fuera de React) y la UI de verificación
// del panel (CORP-599). Cuando el backend rechaza una acción de un panel
// `pending` sin `allow_operations` (HTTP 400, `error_code` 1185), `ApiRest`
// avisa por este evento y `PanelVerificationProvider` abre el modal o el aviso.

// ─── Types ────────────────────────────────────────────────────────────────────

export interface PanelVerificationRequiredDetail {
  /** `true` si quien actúa es owner o super admin: puede verificar el panel. */
  canVerify: boolean;
}

// ─── Constants ────────────────────────────────────────────────────────────────

export const PANEL_VERIFICATION_REQUIRED_EVENT =
  'corporate:panel-verification-required';

/**
 * Tras un 1185 la pantalla que hizo la petición también recibe el error y suele
 * mostrar su propia alerta. Durante esta ventana las alertas de error se
 * omiten: el modal o el aviso ya explican qué pasó.
 */
const DUPLICATE_ALERT_WINDOW_MS = 1500;

let lastRequestedAt = 0;

// ─── API ──────────────────────────────────────────────────────────────────────

export const requestPanelVerification = (
  detail: PanelVerificationRequiredDetail,
): void => {
  lastRequestedAt = Date.now();
  window.dispatchEvent(
    new CustomEvent<PanelVerificationRequiredDetail>(
      PANEL_VERIFICATION_REQUIRED_EVENT,
      { detail },
    ),
  );
};

/** Si una alerta de error genérica debe omitirse porque ya respondió el 1185. */
export const isPanelVerificationPromptActive = (): boolean =>
  Date.now() - lastRequestedAt < DUPLICATE_ALERT_WINDOW_MS;
